import { faAngleRight, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { Associate } from '../../../../global';

type UserProps = {
  user: Associate;
};

const User = ({ user }: UserProps) => {
  const navigate = useNavigate();
  return (
    <li
      className="flex justify-between mx-2 mb-2 h-18 list-none shadow-md rounded-lg pb-4 px-2 pt-2 cursor-pointer bretailer-lh-red bg-white"
      onClick={() => {
        navigate(`/users/${user.id}`);
      }}
    >
      <div className="grid grid-cols-12 w-full">
        <div className="col-span-6">
          <p className="text-lh-head-black align-middle col-span-4 font-bold">
            <FontAwesomeIcon
              icon={faUserCircle}
              className="text-lh-head-black"
            />
            {` ${user.name}`}
          </p>
          <p className="mt-1 text-lh-head-black">{` ${user.phone}`}</p>
        </div>
        <p className="col-span-1 text-right self-center  text-lh-head-black font-bold mr-4">
          <FontAwesomeIcon
            icon={faAngleRight}
            className="text-lh-head-black font-bold align-middle"
          />
        </p>
      </div>
    </li>
  );
};

export default User;
